// @flow
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'vendor/bootstrap/_bootstrap_custom.scss';
import { Field } from 'redux-form';

// Components
import Icon from 'Common/Icon';

// Helpers
import classNames from 'classnames';
import { gtmEventPush } from 'utils/gtm/events';

/**
 * <Input /> component.
 */
class Input extends PureComponent<*, *> {
  /**
   * Implements propTypes().
   *
   * @return {Object} - propType object.
   * @prop {object} styles - Input styles.
   * @prop {string} name - input name.
   * @prop {string} label - label
   * @prop {func} onChangeHandler - change handler
   * @prop {string} selectedValue - value
   */
  static propTypes = {
    styles: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChangeHandler: PropTypes.func,
    selectedValue: PropTypes.string,
    isLabelHidden: PropTypes.bool,
    disablePlaceholder: PropTypes.bool,
    showIcon: PropTypes.bool,
    placeholderText: PropTypes.string,
    isDisabled: PropTypes.bool,
    isValid: PropTypes.bool,
    errorMessage: PropTypes.string,
    resetField: PropTypes.func,
    setRef: PropTypes.func,
    highlight: PropTypes.bool
  };

  onBlurHandler = () => {
    const { label } = this.props;
    gtmEventPush({
      method: 'filterForm',
      args: {
        itemLabel: label
      }
    });
  };

  /**
   * Renders <Input /> component.
   *
   * @return {JSX} - renders an Input.
   */
  render() {
    const {
      styles,
      name,
      label,
      onChangeHandler,
      selectedValue,
      isLabelHidden,
      disablePlaceholder,
      showIcon,
      placeholderText,
      isDisabled,
      isValid,
      errorMessage,
      setRef,
      highlight
    } = this.props;

    return (
      <div
        className={styles.input}
        onClick={() =>
          document.getElementById(name) && document.getElementById(name).focus()
        }
      >
        <label
          className={!isLabelHidden ? bootstrap.srOnly : null}
          htmlFor={name}
        >
          {label}
        </label>
        <Field
          name={name}
          id={name}
          className={classNames(
            bootstrap.formControl,
            styles.select,
            !isValid && highlight ? styles.error : null
          )}
          value={selectedValue}
          placeholder={!disablePlaceholder ? placeholderText : null}
          onChange={event => {
            setTimeout(onChangeHandler, 0);
          }}
          onBlur={this.onBlurHandler}
          component="input"
          disabled={isDisabled}
          ref={setRef}
        />
        {showIcon && (
          <Icon
            iconName={'location'}
            size={'medium'}
            className={classNames(styles.icon, styles.iconPostcode)}
          />
        )}
        {!isValid && errorMessage && (
          <span
            className={
              highlight
                ? classNames(styles.errorMessage, styles.errorMessageHighlight)
                : styles.errorMessage
            }
          >{`* ${errorMessage}`}</span>
        )}
      </div>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/Common/Input/index.js